var _defs, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgOrganization = function SvgOrganization(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    x: "-.2%",
    y: "-3.5%",
    width: "100.3%",
    height: "106.9%",
    filterUnits: "objectBoundingBox",
    id: "a"
  }, /*#__PURE__*/React.createElement("feOffset", {
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0",
    in: "shadowBlurOuter1",
    result: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))), /*#__PURE__*/React.createElement("circle", {
    id: "b",
    cx: 20,
    cy: 20,
    r: 20
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#a)",
    transform: "translate(-18 -14)",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#165E96",
    d: "M0 0h1440v72H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#165E96",
    d: "M0 0h240v72H0z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(20 16)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "c",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#CFD5DA",
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.22 28.54V17.223c0-.59-.486-1.07-1.084-1.07H24.99v-3.078a.8.8 0 00-.417-.7l-4.178-2.3a.796.796 0 00-.07-.034V8.728h2.249c.18 0 .325-.143.325-.32V6.786a.323.323 0 00-.325-.321h-2.25V6.32A.323.323 0 0020 6a.323.323 0 00-.325.32v3.72a.842.842 0 00-.07.035l-4.178 2.3a.8.8 0 00-.417.7v3.079H9.864c-.598 0-1.083.479-1.083 1.07V28.54A1.31 1.31 0 008 29.733c0 .724.594 1.31 1.327 1.31h21.346c.733 0 1.327-.586 1.327-1.31 0-.53-.32-.988-.78-1.193zM27.03 19.88c0-.344.283-.623.632-.623h1.18c.348 0 .63.28.63.623v1.165a.627.627 0 01-.63.623h-1.18a.627.627 0 01-.632-.623v-1.165zm0 3.743c0-.344.283-.623.632-.623h1.18c.348 0 .63.28.63.623v1.165a.627.627 0 01-.63.623h-1.18a.627.627 0 01-.632-.623v-1.165zm-3.792-3.743c0-.344.282-.623.631-.623h1.18c.349 0 .631.28.631.623v1.165a.627.627 0 01-.63.623H23.87a.627.627 0 01-.631-.623v-1.165zm0 3.743c0-.344.282-.623.631-.623h1.18c.349 0 .631.28.631.623v1.165a.627.627 0 01-.63.623H23.87a.627.627 0 01-.631-.623v-1.165zM20 13.077c.987 0 1.788.79 1.788 1.765 0 .974-.8 1.764-1.788 1.764-.987 0-1.788-.79-1.788-1.764 0-.975.8-1.765 1.788-1.765zm-1.79 10.13c0-.344.282-.623.631-.623h2.318c.349 0 .631.28.631.623v4.908c0 .112-.03.218-.083.309h-3.414a.613.613 0 01-.083-.309v-4.908zm-3.892-3.326c0-.344.283-.623.632-.623h1.18c.348 0 .63.28.63.623v1.165a.627.627 0 01-.63.623h-1.18a.627.627 0 01-.632-.623v-1.165zm0 3.743c0-.344.283-.623.632-.623h1.18c.348 0 .63.28.63.623v1.165a.627.627 0 01-.63.623h-1.18a.627.627 0 01-.632-.623v-1.165zm-3.792-3.743c0-.344.282-.623.631-.623h1.18c.349 0 .632.28.632.623v1.165a.627.627 0 01-.632.623h-1.18a.627.627 0 01-.631-.623v-1.165zm0 3.743c0-.344.282-.623.631-.623h1.18c.349 0 .632.28.632.623v1.165a.627.627 0 01-.632.623h-1.18a.627.627 0 01-.631-.623v-1.165z",
    fill: "#FFF",
    fillRule: "nonzero",
    mask: "url(#c)"
  }), /*#__PURE__*/React.createElement("circle", {
    stroke: "#FFF",
    mask: "url(#c)",
    cx: 20,
    cy: 20,
    r: 19.5
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgOrganization, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/organization.61bd4ab8.svg";
export { ForwardRef as ReactComponent };